import { BaseViewDto } from './base.dto';
import { FileCreateAndUpdateDto, FileViewDto, SimpleViewDto } from './common.dto';
import { DateRange, NumberRange } from './formdata.dto';
import { FieldType, SearchAssetPropertyConfig } from './template.dto';

export interface AssetViewDto extends BaseViewDto {
  organisationId: string;
  name: string;
  type: string;
  codeType: string;
  locations: SimpleViewDto[];
  templates: SimpleViewDto[];
  uniqueCode: string;
  status: AssetStatusEnum;
  headerImages: FileViewDto[];
  currentExceptionCount: number;
  assetPropertyData: AssetPropertyValue[];
  createdAt: Date;
  updatedAt: Date;
  isDeleted: boolean;
  lastAuditedAt?: Date;
}

export interface AssetMinDto extends BaseViewDto {
  name: string;
  type: string;
  uniqueCode: string;
}

export interface AssetPropertyValue {
  assetProperty: AssetProperty;
  value: AssetPropertyValueType;
  media?: FileViewDto[];
}

export interface SimpleAssetViewDto extends SimpleViewDto {
  name: string;
  type: string;
  uniqueCode: string;
  locations: SimpleViewDto[];
  status: AssetStatusEnum;
  assetPropertyData: AssetPropertyValue[];
}

export interface AssetCreateDto {
  name: string;
  type: string;
  codeType: string;
  locationIds: string[];
  status: string;
  templateIds: string[];
  uniqueCode?: string;
  headerImages: FileCreateAndUpdateDto[];
  assetPropertyData: AssetPropertyValue[];
}

export interface AssetUpdateDto extends AssetCreateDto {
  id: string;
  confirmUpdate?: boolean;
}

export enum AssetStatusEnum {
  active = 'Active',
  inactive = 'Inactive',
}

export interface OptionType {
  label: string;
  value: string;
}

interface DataOptionDto {
  value: string;
  title: string;
}

interface CoordinatesDto {
  lat: number;
  long: number;
}

interface AssetPropertyConfigFileOption {
  multiple: boolean;
}

export interface AssetPropertyConfig {
  isDecimal?: boolean;
  decimalPoints?: number;
  allowMultiSelect?: boolean;
  range?: boolean;
  date?: boolean;
  time?: boolean;
  fileOption?: AssetPropertyConfigFileOption;
  options?: OptionType[];
  unit?: string;
  url?: boolean;
}

export interface AssetPropertyRuleCountDto {
  assetPropertId: string;
  title: string;
  rulesCount: {
    CL: number;
    VL: number;
    EXPNRL: number;
  };
}

export interface SaveAdvancedAssetPropertyDto {
  id?: string;
  title: string;
  type: FieldType;
  config: AssetPropertyConfig;
}

export interface AssetPropertiesViewDto {
  id: string;
  title: string;
  type: FieldType;
  config?: AssetPropertyConfig;
}

export type AssetPropertyValueType = string | number | DateRange | NumberRange | DataOptionDto[] | CoordinatesDto | FileViewDto[] | FileViewDto;

interface AssetProperty {
  id: string;
  title: string;
  type: FieldType;
  isDeleted: boolean;
  // options?: OptionType[];
  config: AssetPropertyConfig;
  meta?: Record<string, string | number | boolean>;
}

export interface AssetPropertyListDto {
  title: string;
  type: FieldType;
  config?: AssetPropertyConfig;
}

export interface SearchAssetPropertyByAssetIdsConfig {
  assetIds: string[];
  fieldType: FieldType[];
  search?: string;
  config?: SearchAssetPropertyConfig;
}
